import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorkerStatusLookupComponent } from './worker-status-lookup.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [WorkerStatusLookupComponent],
  exports: [WorkerStatusLookupComponent]
})
export class WorkerStatusLookupModule { }
